import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursorList: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCursorList"><Path fillRule="evenodd" clipRule="evenodd" d="M10 3H21V4.5H10V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 7H21V8.5H15V7Z" fill="currentColor"/><Path d="M2.5166 7.0166L7.69647 21.6144L11.8751 17.4358L16.7501 22.3108L17.8108 21.2501L12.9358 16.3751L17.1144 12.1965L2.5166 7.0166Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursorList;
